import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectMutation, QueryClient } from '@tanstack/angular-query-experimental';
import { ActivityTypeService, CreateActivityTypeRequest, UpdateActivityTypeRequest } from '../../../../api';
import { QueryKey } from '../../../constants/query-key';

@Injectable()
export class ActivityTypeCommandService {
  private readonly activityTypeService = inject(ActivityTypeService);
  private readonly queryClient = inject(QueryClient);

  createMutation = injectMutation(() => ({
    mutationFn: (request: CreateActivityTypeRequest) =>
      lastValueFrom(this.activityTypeService.createActivityType(request)),
    onSuccess: () => this.invalidate(),
  }));

  updateMutation = injectMutation(() => ({
    mutationFn: (request: { id: number; body: UpdateActivityTypeRequest }) =>
      lastValueFrom(this.activityTypeService.updateActivityType(request.id, request.body)),
    onSuccess: () => this.invalidate(),
  }));

  deleteMutation = injectMutation(() => ({
    mutationFn: (id: number) =>
      lastValueFrom(this.activityTypeService.deleteActivityType(id)),
    onSuccess: () => this.invalidate(),
  }));

  private invalidate(): void {
    this.queryClient.invalidateQueries({ queryKey: [QueryKey.ACTIVITY_TYPES] });
    this.queryClient.invalidateQueries({ queryKey: [QueryKey.ACTIVITY_TYPES_SELECT] });
  }
}
